import { render, staticRenderFns } from "./CreationDiagnostics.vue?vue&type=template&id=f9fe39b0&scoped=true"
import script from "./CreationDiagnostics.vue?vue&type=script&lang=js"
export * from "./CreationDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./CreationDiagnostics.vue?vue&type=style&index=0&id=f9fe39b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fe39b0",
  null
  
)

export default component.exports